import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppService } from '@app/app.service';
import { MediaStreamModel } from '@modules/media/models/media-stream.model';
import { PlayerPageService } from '@pages/player-page/player-page.service';

@Injectable({
  providedIn: 'root',
})
export class PlayerResolver implements Resolve<Observable<MediaStreamModel | null>> {
  private appService = inject(AppService);
  private service = inject(PlayerPageService);
  private router = inject(Router);

  public resolve(route: ActivatedRouteSnapshot): Observable<MediaStreamModel | null> {
    this.appService.darkBackgroundPage();

    const playerId = route.paramMap.get('playerId');
    if (!playerId) {
      this.router.navigate(['404'], { skipLocationChange: true });
      return EMPTY;
    }

    return this.service.getStreamData(playerId).pipe(
      map((data) => {
        if (!data) {
          this.router.navigate(['404'], { skipLocationChange: true });
          return null;
        } else {
          return data;
        }
      })
    );
  }
}
